
import './StartScreen.scss';
import store from "../store";
import { gameActions } from '../Game/gameSlice';
import { PLAYER_CLASSES } from '../Enums/Attributes';
import { useState } from 'react';
import { ClassNames, SpriteGenderNames } from '../Enums/NameEnums';
import Button from '../Components/Button';
import { getSpriteByGenber as getSpriteByGender } from '../helpers/helpers';
import SpritesheetAsset from '../Components/SpritesheetAsset';

function CharacterSelectionScreen() {

    const [gender, setGender] = useState(SpriteGenderNames.M);
    const [selectedName, setSelectedName] = useState(PLAYER_CLASSES[0].name);
    const [name, setName] = useState("");

    function select(name: ClassNames) {
        setSelectedName(name);
    }

    function renderAttr(attr: number) {
        return attr > 0 ? `+${attr}` : attr;
    }

    function pickCharacter() {
        store.dispatch(gameActions.pickClass({ className: selectedName, name: name.trim() || '', gender: gender }));
    }

    function setSelection(gender) {
        if (gender === SpriteGenderNames.M) {
            document.getElementById("female").classList.remove("selected-gender");
            document.getElementById("male").classList.add("selected-gender");
        } else {
            document.getElementById("male").classList.remove("selected-gender");
            document.getElementById("female").classList.add("selected-gender");
        }

        setGender(gender);
    }

    return (
        <div className="character-selection-screen">

            <div className='character-gender-selection'>
                <div id="male" className='character-gender selected-gender' onClick={() => setSelection(SpriteGenderNames.M)}>
                    <span className={gender === SpriteGenderNames.M ? 'selected' : null} >Lord</span>
                </div>
                <div id="female" className='character-gender' onClick={() => setSelection(SpriteGenderNames.F)}>
                    <span className={gender === SpriteGenderNames.F ? 'selected' : null}>Lady</span>
                </div>
            </div>

            <div className="character-selection">
                {PLAYER_CLASSES.map(it => {
                    return (
                        <div className={`character ${it.name === selectedName ? 'selected' : ''}`} key={it.name} onClick={() => select(it.name)}>

                            <SpritesheetAsset name={getSpriteByGender(it, gender)} multiplier={it.name === selectedName ? 7 : null} />
                            <div className="attributes">
                                {it.hp !== 0 && <div className='attribute-stats'>
                                    <span className='attr-title'>Hp: </span>
                                    <span className='attr-value'>{renderAttr(it.hp)}</span>
                                </div>}
                                {it.att !== 0 && <div className='attribute-stats'>
                                    <span className='attr-title'>Att: </span>
                                    <span className='attr-value'>{renderAttr(it.att)}</span>
                                </div>}
                                {it.def !== 0 && <div className='attribute-stats'>
                                    <span className='attr-title'>Def: </span>
                                    <span className='attr-value'>{renderAttr(it.def)}</span>
                                </div>}
                                {it.pierce !== 0 && <div className='attribute-stats'>
                                    <span className='attr-title'>Prc: </span>
                                    <span className='attr-value'>{renderAttr(it.pierce)}</span>
                                </div>}
                                {it.potion !== 0 && <div className='attribute-stats'>
                                    <span className='attr-title'>Potion: </span>
                                    <span className='attr-value'>{renderAttr(it.potion)}</span>
                                </div>}
                            </div>
                        </div>
                    )
                })}
            </div>

            <div>What is your name?</div>
            <input
                className='character-name-input'
                readOnly={false}
                maxLength={32}
                onChange={e => setName(e.target.value)}
                type="text"
                name="character-name"
                placeholder=""
            />

            <Button text='Ok' disabled={name.length <= 0} onClick={pickCharacter}></Button>
        </div>
    );
}

export default CharacterSelectionScreen;
